<template>
  <section>
    <app-loading v-if="loading" />

    <template v-else>
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center mt-10">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
          <button @click="toggleModalPoints(true)" class="button text-white bg-theme-1 shadow-md mr-2">
            Cargar Puntos
          </button>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">USUARIO</th>
              <th class="text-center whitespace-no-wrap">EVENTO</th>
              <th class="text-center whitespace-no-wrap">FECHA (MES - AÑO)</th>
              <th class="text-center whitespace-no-wrap">PUNTOS</th>
              <th class="text-center whitespace-no-wrap">TIPO</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x" v-for="point in points" :key="`point-${point.slug}`">
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  <div class="flex flex-wrap">
                    <div class="w-full md:w-1/4">
                      <div class="w-24 h-24 lg:w-12 lg:h-12 image-fit mx-auto">
                        <img alt="Profile" class="rounded-full" :src="point.user_avatar" v-if="point.user_avatar">
                        <img alt="Profile" class="rounded-full" src="/static/images/profile.png" v-else>
                      </div>
                    </div>
                    <div class="w-full md:w-3/4 my-auto whitespace-no-wrap">
                      {{ point.user_name }} <br />
                      {{ point.user_email }}
                    </div>
                  </div>
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ point.event }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div v-if="point.month" class="text-gray-600 text-xs whitespace-no-wrap">
                  {{  `${String(point.month).padStart(2, '0')} - ${point.year}` }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ point.value }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ point.type }}
                </div>
              </td>
              <td class="w-40 text-center">
                <button
                    @click="showDeleteModal(point.slug)"
                    class="flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <Icon name="trash" classname="w-4 h-4 mr-2" />Eliminar
                  </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
      <Modal
        title="Eliminar Puntos"
        @close="closeDeleteModal"
        size="lg"
        v-if="showPointsDeleteModal"
      >
        <form @submit.prevent="deletePoints()">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="mt-3 col-span-12 text-center">
              <div>Esta seguro de eliminar los puntos?</div>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 mr-1"
              @click="closeDeleteModal"
            >
              Cancelar
            </button>
            <button type="submit" class="button w-20 bg-theme-1 text-white">
              Eliminar
            </button>
          </div>
        </form>
      </Modal>
    </template>

    <ModalLoadPoints v-if="modalLoadPoints" @close="toggleModalPoints(false)" @upload="uploadedPointsFile" />

  </section>
</template>

<script>
  import { mapActions } from 'vuex'

  import Loading from '@/components/admin/partials/LoadingWhite'
  import axios from '@/services/axios'
  import ModalLoadPoints from '@/components/admin/points/ModalLoadPoints'
  import Icon from '@/components/admin/partials/Icon'
  import Modal from '@/components/assets/Modal/Modal'

  export default {
    name: 'AdminListPoints',
    data () {
      return {
        loading: false,
        points: [],
        modalLoadPoints: false,
        showPointsDeleteModal: false,
        deletePointsSlug: null,
      }
    },
    async beforeMount () {
      try {
        this.loading = true
        this.getPointsFromAxios()
      } finally {
        this.loading = false
      }
    },
    methods: {
      async getPointsFromAxios() {
        try {
          const { data: {data: points} } = await axios.get('/point')

          this.points = points
        } catch (error) {
          console.log(error)
        }
      },
      async deletePoints() {
        try {
          let form = {
              id : this.deletePointsSlug,
              entity : 'point'
          }
          await this.remove(form, 'user')

          window.location.reload()
        } catch (error) {
          console.log(error)
        }
      },
      showDeleteModal(slug) {
        this.deletePointsSlug = slug
        this.showPointsDeleteModal = true
      },
      closeDeleteModal() {
        this.deletePointsSlug = null
        this.showPointsDeleteModal = false
      },
      toggleModalPoints(status) {
        this.modalLoadPoints = status
      },
      async uploadedPointsFile() {
        this.toggleModalPoints(false)
        await this.getPointsFromAxios()
      },
      ...mapActions([
        'remove'
      ])
    },
    components: {
      appLoading: Loading,
      ModalLoadPoints,
      Icon,
      Modal
    },
  }
</script>



// WEBPACK FOOTER //
// ListPoints.vue?585d133c